/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowmorevariants3Inputs */

const en_aiflowmorevariants3 = /** @type {(inputs: Aiflowmorevariants3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New variants`)
};

const de_aiflowmorevariants3 = /** @type {(inputs: Aiflowmorevariants3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Varianten`)
};

/**
* | output |
* | --- |
* | "New variants" |
*
* @param {Aiflowmorevariants3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowmorevariants3 = /** @type {((inputs?: Aiflowmorevariants3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowmorevariants3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowmorevariants3(inputs)
	return de_aiflowmorevariants3(inputs)
});
export { aiflowmorevariants3 as "aiFlowMoreVariants" }